import * as React from "react";
import { SVGProps } from "react";
export function QualityEducationIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 16.189 19.999"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.177 9.357c-1.067-.79-2.67-2.172-7.26-2.172v9.892c4.59 0 6.193 1.382 7.26 2.172V9.357ZM8.178 9.357c1.067-.79 2.67-2.172 7.261-2.172v9.892c-4.592 0-6.194 1.382-7.261 2.172V9.357ZM13.553.75H4.015c-.267 0-.528.075-.754.215L.75 2.525l2.51 1.56c.227.141.488.216.755.216h9.538a1.775 1.775 0 0 0 0-3.551ZM11.014.826v3.475"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
